import React from 'react';
// CRA 3.4 / webpack 4 gotcha (see recipe-cost notes): import lucide from the UMD
// build, NOT the package root, or webpack hard-errors on the ESM `.mjs` entry.
import * as LucideNS from 'lucide-react/dist/umd/lucide-react.js';

// Depending on webpack's interop, the UMD exports may land directly on the
// namespace or under `.default`. Resolve whichever actually holds the icons.
const Lucide = LucideNS && LucideNS.Square ? LucideNS : LucideNS.default || LucideNS;

/**
 * Render a lucide icon by name so the registry can carry icon names as strings.
 * Falls back to a neutral square if the name is unknown.
 */
export default function Icon({ name, size = 20, strokeWidth = 2, className, style, color }) {
  const Cmp = (name && Lucide[name]) || Lucide.Square;
  return (
    <Cmp
      size={size}
      strokeWidth={strokeWidth}
      className={className}
      style={style}
      color={color}
      aria-hidden="true"
    />
  );
}
